import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import ModalPop from '../modal/modal';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const FlatFileUpload = ({
  handleModalHide = null,
  handlebulkSubmit = null,
  isbulk = null,
  handleFileChange = null,
  isUploaded = null,
  sampleData = null,
  getList,
  redirectUrl = '/preSalesListing',
  redirectName = localization.preSales,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  return (
    <Fragment>
      <ModalPop
        title={
          sampleData?.file_url
            ? localization.DownloadFlatFile
            : localization.uploadFlats
        }
        show={isbulk && true}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
        footer={!isUploaded && !sampleData?.file_url && true}
        footerSubmitTxt={localization.submit}
        handleModalSubmit={handlebulkSubmit}
      >
        <div className="bulk_upload text-center">
          {isUploaded && (
            <Fragment>
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
              <p>{localization.uploadSuccess}</p>
              <Link
                to={`${baseUrl}${redirectUrl}`}
                className="btn btn-primary mb-4"
                onClick={() => {
                  handleModalHide();
                  getList();
                }}
              >
                {redirectName} <img src={Images?.ArrowRight} alt="" />
              </Link>
            </Fragment>
          )}
          {!isUploaded && (
            <div style={{ margin: '4px' }}>
              {sampleData?.file_url ? (
                <a
                  className="btn btn-primary w-auto ml-2"
                  href={sampleData && sampleData.file_url}
                  download
                >
                  {localization.downloadFlats}
                </a>
              ) : (
                <>
                  <br />
                  <br />
                  <FileUpload
                    isBase64={true}
                    id="bulk_upload"
                    accept=".csv"
                    onChange={(val) => {
                      handleFileChange(val);
                    }}
                  >
                    <span className="btn btn-transparent">
                      {localization.uploadFlats}
                    </span>
                  </FileUpload>
                </>
              )}
            </div>
          )}
        </div>
      </ModalPop>
    </Fragment>
  );
};

FlatFileUpload.propTypes = {
  handleModalHide: PropTypes.func,
  handlebulkSubmit: PropTypes.func,
  isbulk: PropTypes.any,
  handleFileChange: PropTypes.func,
  isUploaded: PropTypes.bool,
};

export default FlatFileUpload;
